import aipache from "./aipache.json";
import apache from "./apache.json";
import jicar from "./jicar.json";
import mesca from "./mesca.json";
import type { Character } from "../../types";

export const characters: Character[] = [apache, aipache, jicar, mesca];

export const getCharacter = (id: string): Character | undefined => {
	return characters.find((c) => c.id === id);
};
